const initialState = {
  advantages: null,
  advantagesDiscount: null,
  advantagesSegments: null,
};

export default initialState;